<template>
  <div class="main">
    <div class="boxVideo">
      <video playsinline autoplay muted loop>
        <source src="../assets/videos/vinheta_web.mp4" type="video/mp4">
        Your browser does not support HTML5 video.
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
position:relative;
width: 100%;
height: 100%;
display: flex;
flex-direction: row;
justify-content: center;
}
.boxVideo{
width: 100%;
height: 95%;
align-self: center;
display:flex;
flex-direction: row;
justify-content: center;
margin:0 0 0 -80px;
}

.boxVideo img{
height:100%;
}

</style>
